import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  AggiornamentoAnagraficaTimesheet,
  AnagraficaTimesheet,
  MancataPresaVisione,
  StatoPresaVisioneTimesheet,
  Timesheet,
} from '../interfaces/timesheet.interface';
import { FiltroCommesse } from '../interfaces/filtro-commesse.interface';
import { Attori } from '../shared/enum/attori.enum';

@Injectable({
  providedIn: 'root',
})
export class TimesheetService {
  constructor(private http: HttpClient) {}

  baseUrl = 'api/Timesheet';

  getRisorsa(): Observable<Timesheet[]> {
    return this.http.get<any>(this.baseUrl + '/risorsa');
  }

  getDettaglioRisorsa(): Observable<Timesheet[]> {
    return this.http.get<any>(this.baseUrl + '/responsabile/risorsa');
  }

  getDettaglioRisorsaRPL(): Observable<Timesheet[]> {
    return this.http.get<any>(
      this.baseUrl + '/responsabilePrimoLivello/risorsa'
    );
  }

  getAnagraficaTimeSheet(): Observable<AnagraficaTimesheet> {
    return this.http.get<AnagraficaTimesheet>(
      this.baseUrl + '/anagraficaTimeSheet'
    );
  }

  getAnagraficaTimeSheetControllerCentrali(): Observable<AnagraficaTimesheet> {
    return this.http.get<AnagraficaTimesheet>(
      this.baseUrl + '/controllerCentrali/anagraficaTimeSheet'
    );
  }

  updateAnagraficaTimeSheet(
    form: AggiornamentoAnagraficaTimesheet
  ): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + '/aggiornaAnagraficaTimesheet',
      form
    );
  }

  presaVisione(): Observable<any> {
    return this.http.patch(this.baseUrl + '/presaVisione', null);
  }

  getStatoPresaVisioneTimesheet(): Observable<StatoPresaVisioneTimesheet> {
    return this.http.get<StatoPresaVisioneTimesheet>(
      this.baseUrl + '/statoPresaVisioneTimesheet'
    );
  }

  getDettaglioStatoPresaVisioneTimesheet(): Observable<StatoPresaVisioneTimesheet> {
    return this.http.get<StatoPresaVisioneTimesheet>(
      this.baseUrl + '/responsabile/risorsa/statoPresaVisioneTimesheet'
    );
  }

  // getTimesheetLivelloCommesse(): Observable<Timesheet[]> {
  //   return this.http.get<Timesheet[]>(
  //     this.baseUrl + '/responsabile/timesheetcommesse'
  //   );
  // }

  ricercaTimesheetLivelloCommesse(filter: FiltroCommesse): Observable<any> {
    const responseType = filter.flagExport ? 'blob' : 'json';
    const body = { ...filter };

    return this.http.post<Timesheet[]>(
      this.baseUrl + '/responsabile/timesheetcommesse/ricerca',
      body,
      { responseType: responseType as any }
    );
  }

  ricercaTimesheetLivelloCommesseCount(
    filter: FiltroCommesse
  ): Observable<any> {
    const body = { ...filter };
    return this.http.post<Timesheet[]>(
      this.baseUrl + '/responsabile/timesheetcommesse/ricerca/count',
      body
    );
  }

  mancataPresaVisione(
    mancataPresaVisione: MancataPresaVisione
  ): Observable<any> {
    return this.http.patch<any>(
      this.baseUrl + '/mancataPresaVisione',
      mancataPresaVisione
    );
  }

  mancataPresaVisioneMassiva(
    mancataPresaVisione: MancataPresaVisione[]
  ): Observable<any> {
    return this.http.patch<any>(
      this.baseUrl + '/mancataPresaVisioneMassiva',
      mancataPresaVisione
    );
  }

  getDettaglioRisorsaDaPianificazioneController(
    attore: Attori,
    idAnagraficaTimesheet: number,
    matricola: string
  ): Observable<Timesheet[]> {
    switch (attore) {
      case Attori.PianificazioneControllo:
        return this.http.post<Timesheet[]>(
          this.baseUrl + '/pianificazioneControllo/risorsa',
          {
            idAnagraficaTimesheet: idAnagraficaTimesheet.toString(),
            risorsa: matricola,
          }
        );
      case Attori.ControllerCentrale:
        return this.http.post<Timesheet[]>(
          this.baseUrl + '/controllerCentrale/risorsa',
          {
            idAnagraficaTimesheet: idAnagraficaTimesheet.toString(),
            risorsa: matricola,
          }
        );
      case Attori.ControllerBU:
        return this.http.post<Timesheet[]>(
          this.baseUrl + '/controllerBU/risorsa',
          {
            idAnagraficaTimesheet: idAnagraficaTimesheet.toString(),
            risorsa: matricola,
          }
        );
      default:
        return of([]);
    }
  }
}
